var _g, _circle, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_5741_3003)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 120,
    fill: "#F6F3EF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5741_3003",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 240,
    height: 240
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 120,
    fill: "#162E4F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5741_3003)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M195.787 195.57C195.787 198.858 162.481 201.521 121.394 201.521C80.3072 201.521 47 198.858 47 195.57C47 192.283 80.3072 189.619 121.394 189.619C162.481 189.619 195.787 192.283 195.787 195.57Z",
    fill: "#DCDCDC",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2151 66.1206V98.6387L57.1211 82.1882L79.2151 66.1206Z",
    fill: "#ECC9A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M185.668 82.1882L163.574 98.6387V66.1206L185.668 82.1882Z",
    fill: "#ECC9A2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M185.668 82.1884V158.513C185.668 160.963 184.583 163.152 182.855 164.619L139.731 116.373L185.668 82.1884Z",
    fill: "#E4B47F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M182.854 164.619C181.449 165.824 179.621 166.547 177.632 166.547H65.1544C63.1659 166.547 61.3381 165.824 59.9321 164.619L103.055 116.373L121.393 130.031L139.731 116.373L182.854 164.619Z",
    fill: "#FFCF9A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.056 116.373L59.9331 164.619C58.2058 163.152 57.1211 160.963 57.1211 158.513V82.1884L103.056 116.373Z",
    fill: "#E4B47F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3002 158.514H91.2661V154.497H99.3002V158.514Z",
    fill: "#FFE7CD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.523 158.514H103.317V154.497H151.523V158.514Z",
    fill: "#FFE7CD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M139.471 150.477H91.2661V146.46H139.471V150.477Z",
    fill: "#FFE7CD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151.522 150.477H143.487V146.46H151.522V150.477Z",
    fill: "#FFE7CD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.072 42.9376V90.7796L121.394 130.029L68.7158 90.7796V42.9376C68.7158 40.7294 70.3477 37.9986 72.5569 37.9986H169.133C171.343 37.9986 174.072 40.7294 174.072 42.9376Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.68 99.092H101.162V72.3383L84.7593 60.5352V94.3708C84.7593 96.9793 86.9613 99.092 89.68 99.092Z",
    fill: "#4285F4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M140.528 99.092H152.01C154.728 99.092 156.93 96.9793 156.93 94.3708V60.5352L140.528 72.3383V99.092Z",
    fill: "#34A853"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M140.528 51.8805V72.3392L156.93 60.5361V54.2411C156.93 48.4064 149.988 45.074 145.121 48.5756L140.528 51.8805Z",
    fill: "#FBBC04"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.162 72.3376V51.8789L120.845 66.0427L140.528 51.8789V72.3376L120.845 86.5014L101.162 72.3376Z",
    fill: "#EA4335"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7593 54.2411V60.5361L101.162 72.3392V51.8805L96.569 48.5756C91.7016 45.074 84.7593 48.4064 84.7593 54.2411Z",
    fill: "#C5221F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M185.667 82.1884V158.513C185.667 160.963 184.583 163.152 182.855 164.619L181.891 163.534C182.996 162.168 183.659 160.421 183.659 158.513V83.6753L185.667 82.1884Z",
    fill: "#C18747"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M182.854 164.618C180.353 166.762 177.964 166.547 175.624 166.547C178.281 166.547 180.648 165.191 181.89 163.533L182.854 164.618Z",
    fill: "#E17907"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M139.47 146.46V150.477H137.46V146.46H139.47Z",
    fill: "#D18B8B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M151.522 154.497V158.514H149.514V154.497H151.522Z",
    fill: "#D18B8B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2996 154.497V158.514H97.291V154.497H99.2996Z",
    fill: "#D18B8B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M151.522 146.46V150.477H149.514V146.46H151.522Z",
    fill: "#D18B8B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_5741_3003",
    x: 0,
    y: 0,
    width: 240,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_5741_3003"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.82fc42d695aea2a2f2a32b482d986520.svg";
export { ForwardRef as ReactComponent };